// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2SWtw","header":"MergedInvoice_header__2ch7f"};